
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.765 20h18.47c.423 0 .765-.407.765-.91V.91c0-.503-.342-.91-.765-.91H.765C.342 0 0 .407 0 .91v18.18c0 .503.342.91.765.91zm6.94-13.636c0-.336.155-.644.403-.802a.665.665 0 01.786.045l4.592 3.637c.213.168.34.452.34.756a.965.965 0 01-.34.756l-4.592 3.637a.664.664 0 01-.786.045c-.248-.158-.404-.466-.404-.802V6.364z","fill":"#E2E8F0"}})])
          )
        }
      }
    